import { createComponent } from '@mtfe/sweet';
import {
    eventBus,
    common,
    createDeepLink,
    createObserve,
    dom,
} from '@mtfe/sweet-utils';
import { CouponListC, componentUtils } from '@mtfe/sweet-components';

import style from './style.less';
import tpl from './dom.html';
import store from '../../store';

import http from '../../service';
import { filterNewCoupon } from '../../utils/filter';
import { fetchAllCoupon } from '../../utils/fetchData';
import { useAutoLogin } from '../../utils';
import { COUPON_STATUS } from '../../constants/index';

const { debounceByPromise, createUniqueId } = common;
const { storeCommon } = store;
const deepLink = createDeepLink();
const { getPoiContainerID } = componentUtils;

const couponListMonitor = (listUniqueId) => {
    const { structInfo } = storeCommon;
    const { dom_sg_every_day_coupon: domSgEveryDayCoupon } = structInfo.struct;
    const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];
    const couponDomList = Array.from(
        document.querySelectorAll(`#${listUniqueId} [coupon-monitor-index]`),
    );
    const observeCb = async (err, item) => {
        if (err) {
            return;
        }
        const componentID = CouponListC.describe.getComponentID();
        try {
            const currentIndex = item.target.getAttribute(
                'coupon-monitor-index',
            );
            const currentCouponList =
                storeSgEveryDayCoupon.discountData.couponList;
            const url = `${currentCouponList[currentIndex].impMonitorUrl}&componentId=${componentID}`;
            await http.gMonitorApi(url);
        } catch (error) {
            console.error('曝光失败', error);
        }
    };
    if (couponDomList.length) {
        createObserve(observeCb, couponDomList);
    }
};

const ShangouCouponListReady = (shangouListId) => {
    eventBus.$on('ShangouCouponListReady', () => {
        couponListMonitor(shangouListId);
    });
};

const ShangouCouponList = (props) => {
    try {
        const { couponListInfo, welfareIndex } = props;
        const { couponList = [], recallBizId, giftValue } = couponListInfo;

        const SG_EVERY_DAY_ID = createUniqueId();
        const shangouListId = createUniqueId();

        const onBatchRecvClickHandler = debounceByPromise(
            useAutoLogin(async () => {
                // 这个数组必须定义在领券之前
                const newCouponPoiList = filterNewCoupon(couponList);
                try {
                    await fetchAllCoupon(couponList, recallBizId);

                    const couponListContainer =
                        document.getElementById(SG_EVERY_DAY_ID);

                    if (couponListContainer) {
                        couponListContainer.innerHTML = ShangouCouponList({
                            couponListInfo,
                            welfareIndex,
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
                // 领券之后，带参数上报商家的点击
                // 领券失败也要上报
                const componentID = CouponListC.describe
                    .getSubComponent('ReceiveAll')
                    .getComponentID();
                newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
                    const url = `${poiInfoOfNewCouponList.clickMonitorUrl}&componentId=${componentID}`;
                    http.actGeClkM(url);
                });
            }),
            500,
        );

        // 点击券领取
        const onCouponClickHandler = debounceByPromise(
            useAutoLogin(async (poiInfo) => {
                const { giftInfo } = poiInfo;
                if (giftInfo && giftInfo.status === COUPON_STATUS.STATUS_NEW) {
                    // 这个数组必须定义在领券之前
                    const newCouponPoiList = filterNewCoupon(couponList);
                    try {
                        await fetchAllCoupon(couponList, recallBizId);
                        const couponListContainer =
                            document.getElementById(SG_EVERY_DAY_ID);
                        if (couponListContainer) {
                            couponListContainer.innerHTML = ShangouCouponList({
                                couponListInfo,
                                welfareIndex,
                            });
                        }
                    } catch (error) {
                        console.error(error);
                    }
                    // 领券之后，带参数上报商家的点击
                    // 领券失败也要上报
                    const componentID = CouponListC.describe
                        .getSubComponent('ReceiveAll')
                        .getComponentID();
                    newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
                        const url = `${poiInfoOfNewCouponList.clickMonitorUrl}&componentId=${componentID}`;
                        http.actGeClkM(url);
                    });
                }

                const componentID = CouponListC.describe
                    .getSubComponent('Coupon')
                    .getComponentID();
                const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;

                // 此处不再需要单独上报
                deepLink.gotoDp(poiInfo.dpUrl, poiInfo.lpUrl, () => {
                    http.actGeClkM(url);
                });
            }),
            500,
        );

        ShangouCouponListReady(shangouListId);
        const data = {
            couponListDom: CouponListC({
                giftInfoList: couponList,
                welfareIndex,
                title: `${giftValue / 100}元超值券包`,
                onCouponClick: onCouponClickHandler,
                onBatchRecvClick: onBatchRecvClickHandler,
                onBatchUseClick: () => {
                    const SgEveryDayCouponDom = dom.$id(
                        getPoiContainerID(recallBizId),
                    );
                    if (SgEveryDayCouponDom) {
                        const top =
                            SgEveryDayCouponDom.getBoundingClientRect().top -
                            96;
                        window.scrollBy({
                            top,
                            behavior: 'smooth',
                        });
                    }
                    // const SgLargeRedBagDom = dom.$id(sgRedBagModuleDomId);
                    // const SgEveryDayCouponDom = dom.$id(
                    //     getPoiContainerID(domSgEveryDayCoupon.recallBizId),
                    // );

                    // let top = 0;
                    // if (SgLargeRedBagDom) {
                    //     // 存在福利二与福利一
                    //     top = SgLargeRedBagDom.getBoundingClientRect().top - 40;
                    // } else if (SgEveryDayCouponDom) {
                    //     // 只存在福利一
                    //     top = SgEveryDayCouponDom.getBoundingClientRect().top - 40;
                    // }
                },
                listUniqueId: shangouListId,
            }),
            SG_EVERY_DAY_ID,
        };
        return createComponent(tpl, { data, style }, {});
    } catch (error) {
        console.error(error);
        return '';
    }
};

export default ShangouCouponList;
